module.exports = __webpack_public_path__ + "img/download-en.ead3f52d.png";